<hr class="mt-0" />

<div class="w-full category-picker">
  <!--
    Inline tree rather than a p-treeSelect dropdown, matching the pool filter.
    This dialog exists only to pick categories, so a dropdown meant an overlay
    that had to escape the dialog containing it - it was clipped or hung off the
    bottom edge. Inline, the tree fills the dialog and scrolls on its own.
  -->
  <p-tree
    [value]="careerPaths"
    [(selection)]="selected"
    selectionMode="checkbox"
    [filter]="true"
    filterPlaceholder="{{ 'layout.configurations.evaluation.addEvaluationFilter.searchPlaceholder' | translate }}"
    filterBy="label"
    scrollHeight="22rem"
    styleClass="category-tree"
    emptyMessage="{{ 'layout.configurations.evaluation.addEvaluationFilter.noCategories' | translate }}">
  </p-tree>

  <div class="save-bar">
    <span class="selection-count">
      {{ selectedCategoryCount }}
      {{ 'layout.configurations.evaluation.addEvaluationFilter.selectedSuffix' | translate }}
    </span>
    <p-button
      label="{{ 'layout.configurations.evaluation.addEvaluationFilter.save' | translate }}"
      styleClass="p-button-sm"
      [loading]="saving"
      [disabled]="saving"
      (onClick)="submitData()">
    </p-button>
  </div>
</div>
